import { render, staticRenderFns } from "./CentroOncologiaComponente.vue?vue&type=template&id=9df2f576&scoped=true"
import script from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
export * from "./CentroOncologiaComponente.vue?vue&type=script&lang=js"
import style0 from "./CentroOncologiaComponente.vue?vue&type=style&index=0&id=9df2f576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9df2f576",
  null
  
)

export default component.exports